<template>
	<Panel v-if="quiniela.creador" :title="mostrarPrediccionTitulo" :icon="'check-square'">
		<div class="partidos-quiniela" :class="{ 'has-footer': quiniela.estado == 0 && quiniela.tipo == 1 && !usuarioEnQuiniela()}">

			<div class="panel-block bbottom is-block" v-for="(partido,key) in quiniela.partidos" :key="key">
				<div class="columns equipos-partido is-mobile">
					<div class="column">{{ partido.equipo_local.nombre }}</div>
					<transition name="card" mode="out-in">
					<div :key="(jugador) ? jugador.id:quiniela.creador.id" class="column has-text-centered" v-html="mostrarPrediccion(partido)"></div>
					</transition>
					<div class="column has-text-right">{{ partido.equipo_visitante.nombre }}</div>
				</div>
				<div class="horario-partido">
					<font-awesome-icon class="" icon="calendar-alt"/> <span> {{ mostrarFecha(partido.inicia_tz) }}</span>
				</div>

			</div>

			<div class="panel-block panel-footer" v-if="quiniela.estado == 0 && quiniela.tipo == 1 && quiniela.privada == 0 && !usuarioEnQuiniela()">
				<button class="button is-info is-small is-fullwidth" @click.prevent="unirseQuiniela">
					<span class="icon"><font-awesome-icon icon="check-square"/></span>
					<span>Unirme a esta quiniela ({{ quiniela.apuesta }} pts)</span>  
				</button>
			</div>

			<div class="panel-block panel-footer" v-if="quiniela.estado == 0 && quiniela.tipo == 1 && quiniela.privada == 1 && !usuarioEnQuiniela()">
				<p v-if="usuarioEnSolicitudes()" class="has-text-centered"><font-awesome-icon icon="paper-plane" /> Tu solicitud para unirte ya fue enviada</p>
				<button v-if="!usuarioEnSolicitudes()" class="button is-primary is-small is-fullwidth" @click.prevent="unirseQuiniela">
					<span class="icon"><font-awesome-icon icon="lock"/></span>
					<span>Solicitar unirme a la quiniela <span class="is-hidden-tablet-only">({{ quiniela.apuesta }} pts)</span></span>  
				</button>
			</div>
		</div>
	</Panel>
</template>

<script>
	import Panel from '@/components/Panel'
	import { mapState,mapGetters } from 'vuex'
	export default {
		props: {
			quiniela: {
				type: Object,
				required: true
			},
			jugador: {
				type: Object,
				required: false
			}
		},
		components: { Panel },
		name: 'PartidosQuiniela',

		data() {
			return {

			};
		},
		computed: {
			mostrarPrediccionTitulo(){
				let aciertos
				let jugador = (this.quiniela.tipo == 0) ? 
					this.quiniela.creador:
					(this.jugador) ? this.jugador:
					(this.loggedIn && this.usuarioEnQuiniela()) ? this.usuarioEnQuiniela() : this.quiniela.creador
				
				if (this.quiniela.estado > 1 && typeof jugador.predicciones !== "undefined") {
					aciertos = jugador.predicciones.filter(pred => pred.acerto == 1).length
				}
				if (this.loggedIn) {
					if (jugador.id == this.user.user.id) {
						return 'Mi quiniela ' + (typeof aciertos !== "undefined" ? '(' + aciertos + ' aciertos)':'')
					}
				}
				return 'Quiniela de ' + jugador.name + (typeof aciertos !== "undefined" ? ' (' + aciertos + ' aciertos)':'')
			},
			...mapState('user',['user']),
			...mapGetters(['loggedIn'])
		},
		methods: {
			usuarioEnQuiniela(){
				if (this.loggedIn) {
					let userid = this.user.user.id
					return this.quiniela.jugadores.find(jugador => jugador.id === userid)
				}else{
					return false
				}
			},
			mostrarPrediccion(partido){
				let jugador = (this.jugador) ? this.jugador:this.usuarioEnQuiniela()
				let prediccion = false

				if ((this.quiniela.privada && !jugador) || (this.quiniela.estado == 0 && this.quiniela.tipo == 1 && !jugador) ) {
					return '?'
				}

				if ((this.quiniela.privada || this.quiniela.estado == 0) && !this.usuarioEnQuiniela() ) {
					return '?'
				}

				if (jugador) {
					prediccion = jugador.predicciones.find(prediccion => prediccion.id_partido === partido.id)
				}else{
					prediccion = this.quiniela.jugadores[0].predicciones.find(prediccion => prediccion.id_partido === partido.id)
				}

				if (this.quiniela.estado == 0 || this.quiniela.estado == 1) {
					return prediccion.resultado
				}
				if (this.quiniela.estado == 2 || this.quiniela.estado == 3) {
					if (partido.estado == 2) {
						let color = prediccion.acerto ? 'is-info':'is-danger'
						return '<span class="tag is-normal ' + color + '">' + prediccion.resultado + '</span>'
					}else{
						return prediccion.resultado
					}
				}
			},
			mostrarFecha(fecha){
				let dObject = new Date(fecha);
				return dObject.toDateString() + ' ' + dObject.toLocaleTimeString()
			},
			unirseQuiniela(){
				this.$emit('unirseClick');
			},
			usuarioEnSolicitudes(){
				if (this.loggedIn) {
					return this.quiniela.solicitudes.find(q => q.user_id == this.user.user.id);
				}
				return false
			}
		}
	};
</script>

<style lang="css" scoped>
.partidos-quiniela{
}
.partidos-quiniela.has-footer{
	padding-bottom: 3em;
}
.partidos-quiniela .panel-block{
	width: 100%;
}
.equipos-partido{
	margin-bottom: -0.3em !important;
	font-size: 0.8em;
}
.horario-partido{
	font-size: 0.7em;
	letter-spacing: -0.05em;
	color: #666;
}
.column{
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>
